<template>
	<div style="background-color: #ffffff;padding-left: 10px;padding-top: 16px;" class="orderlist">
		<!-- 搜索 -->
		<div class="order_search">
			<span class="ddss">场景名称</span>
			<div class="el-input" style="width: 280px;">
				<input type="text"
				  v-model="scene_name"
				  @keyup.enter="getList(1)"
				  autocomplete="off" placeholder="请输入场景名称" class="el-input__inner">
			</div>
			
			<span class="ddss margin-left-30">邀请编号</span>
			<div class="el-input" style="width: 280px;">
				<input type="text"
				  v-model="invite_code"
				  @keyup.enter="getList(1)"
				  autocomplete="off" placeholder="请输入邀请编号" class="el-input__inner">
			</div>
	
			<span class="ddss margin-left-30">创建时间</span>
			<el-date-picker v-model="date_val" type="datetimerange"
				value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
			</el-date-picker>
		</div>
	
		<div class="cx" @click="getList(1)">查询</div>
		<div class="dc" @click="showAddInviteqr()">创建邀请码</div>
		
		<!-- 表格 -->
		<div :style="!(tableData.length==0 && !loading) ? 'min-height: 480px' : ''" >
			<el-table v-loading="loading" :data="tableData" ref="tableRef">
				<el-table-column prop="" label="邀请码" align="center" width="100">
					<template slot-scope="scope">
						<div class="imgs_">
							<img :src="scope.row.qrcode_url"
								style="width: 40px;height: 40px;object-fit: cover;border-radius: 2px;" />
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="scene_name" label="场景名称" :show-overflow-tooltip="true" align="center">
					<template slot-scope="scope">
						{{scope.row.scene_name}}
					</template>
				</el-table-column>
				<el-table-column prop="invite_code" label="邀请编号" align="center">
				</el-table-column>
				
				<el-table-column prop="ctime" label="创建时间" align="center">
				</el-table-column>
				<el-table-column prop="remarks" label="备注" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<p v-if="scope.row.remarks">{{scope.row.remarks}}</p>
						<p v-else>——</p>
					</template>
				</el-table-column>
				<el-table-column prop="stay_commission" fixed="right" label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="medium " @click="add_desc(scope.row.id,scope.row.remarks)">备注</el-button>
						<el-button type="text" size="medium " @click="downloadQr(scope.row.scene_name,scope.row.invite_code,scope.row.qrcode_url)">下载</el-button>
						<el-button type="text" size="medium " @click="del(scope.$index,scope.row.id,scope.row.invite_code)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="orderlist_note">
			<el-dialog title="备注" :visible.sync="show_desc" :before-close="close_desc" :close-on-click-modal="false">
				<el-input class="gp-textarea" type="textarea" v-model="remarks" placeholder="请填写"
					maxlength="200">
				</el-input>
				<div slot="footer">
					<el-button @click="close_desc">取消</el-button>
					<el-button type="primary" @click="send_desc">确定</el-button>
				</div>
			</el-dialog>
		</div>
		
		<!-- 分页器 -->
		<div class="block" style="padding: 40px;background: #ffffff;">
			<el-pagination background align='center' @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" :pager-count='5'
				layout="total, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		
		<add-inviteqr :show="addInviteqrShow" @close="closeAddInviteqr" @success="successAddInviteqr"></add-inviteqr>
	</div>
</template>

<script>
	import {
		getInviteqrList,
		setInviteqrRemark,
		delInviteqr
	} from '../../api/point';
	import { baseURL, noPermissionCode} from '@/config';
	import addInviteqr from '@/components/point/add-inviteqr.vue';
	
	export default {
		components: {
			addInviteqr // 添加
		},
		data() {
			return {
				remarks: '',
				tableData: [], //列表数据
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				pageSize: 10, // 每页的数据条数
				loading: true,
				scene_name:'', //场景名称
				invite_code:'', // 邀请编号
				date_val: '', // 创建时间筛选
				Inthe_id:0, // 当前操作id
				show_desc: false,
				url:baseURL+"/Api/brand.NoAuth/downloadImg?down_url=",
				addInviteqrShow: false, //是否显示创建邀请码弹框
			}
		},
		created() {
			let keypage = localStorage.getItem('keypage');
			if (keypage) {
				this.currentPage = parseInt(keypage);
				localStorage.setItem('keypage', '')
			}
		
			this.getList();
		},
		methods: {
			close_desc() {
				this.show_desc = false;
				this.remarks = '';
			},
			send_desc() {
				var id = this.Inthe_id;
				var remarks = this.remarks;
				
				setInviteqrRemark({
					invite_id: id,
					remarks: remarks
				}).then(res => {
					this.show_desc = false;
					if (res.code == 0) {
						this.getList();
						this.$message.success(res.message);
					} else {
						this.getList();
						this.$message.error(res.message);
					}
				})
			},
			getList(is_s = 0) {
				if (this.date_val) {
					var s_time = this.date_val[0];
					var e_time = this.date_val[1];
				} else {
					var s_time = '';
					var e_time = '';
				}
				if (is_s) {
					this.currentPage = 1;
				}
		
				this.loading = true;
				getInviteqrList({
					'page': this.currentPage,
					'pageSize': this.pageSize,
					'start_time': s_time,
					'end_time': e_time,
					'scene_name': this.scene_name,
					'invite_code': this.invite_code,
				}).then(res => {
					if (res.code == 0) {
						this.total = res.data.count;
						this.loading = false;
						this.tableData = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				})
			},// 删除
			del(idx=0,id=0,invite_code){
				// 弹出确认框
				this.$confirm('您确认要删除编号【'+invite_code+'】吗？', '提示', {
					confirmButtonText: '确认删除',
					cancelButtonText: '取消',
					confirmButtonClass:'confrim-btn'
				}).then(() => {
					delInviteqr({
						invite_id: id
					}).then(res => {
						if (res.code == 0) {
							this.tableData.splice(idx,1);
							this.$message.success(res.message);
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
				
				});
			},
			// 下载
			downloadQr(scene_name,invite_code,qrUrl){
				var link = document.createElement("a");
				link.href = this.url + qrUrl + '&title=' + scene_name + '_' +invite_code;
				link.click();
				link.remove();
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			},
			// 添加备注
			add_desc(id, desc) {
				this.Inthe_id = id;
				this.remarks = desc;
				this.show_desc = true;
			},
			// 添加 弹框
			showAddInviteqr(){
				this.addInviteqrShow = true;
			},
			
			// 关闭添加
			closeAddInviteqr() {
				this.addInviteqrShow = false
				this.getList();
			},
			successAddInviteqr() {
				this.addInviteqrShow = false
				this.getList(1);
			},
		}
	}
</script>

<style>
	.orderlist_note >>> .el-dialog {
		width: 424px;
		height: 230px;
	}

	.orderlist_note >>> .gp-textarea textarea {
		height: 100px;
	}

	.orderlist_note >>> .el-dialog__body{
		padding: 5px 20px;
	}

	.father-main {
		overflow: auto;
	}

	/* 	.el-dialog{
		    width: fit-content;
	} */
	body .el-table th.gutter {
		display: table-cell !important;
	}

	body .el-table colgroup.gutter {
		display: table-cell !important;
	}

	.el-table__body {
		/* // 使表格兼容safari，不错位 */
		width: 100%;
		table-layout: fixed !important;
	}

	.order_search {
		height: 40px;
		margin-left: 5px;
		margin-bottom: 16px;
		display: flex;
		align-items: center;
	}
	
	.order_search .el-select {
		width: 150px;
	}

	.ddss {
		margin-right: 10px;
		font-size: 14px;
		font-weight: 500;
		color: #333333;
	}

	.cx {
		width: 102px;
		height: 40px;
		display: inline-block;
		background: #0486FE;
		border-radius: 4px;
		text-align: center;
		line-height: 40px;
		font-size: 14px;
		font-weight: 500;
		color: #FFFFFF;
		cursor: pointer;
	}

	.dc {
		display: inline-block;
		width: 93px;
		height: 40px;
		background: #FF8700;
		border-radius: 4px;
		text-align: center;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 40px;
		margin-left: 20px;
		cursor: pointer;
	}

	.imgs_ {
		width: 40px;
		height: 40px;
		margin: 0 auto;
		position: relative;
	}

	.el-tooltip__popper {
		max-width: 20% !important;
	}

	.el-tooltip__popper,
	.el-tooltip__popper.is-dark {
		max-width: 20% !important;
		background: rgb(48, 65, 86) !important;
		color: #fff !important;
		line-height: 24px;
	}
	
	.margin-left-30 {
		margin-left: 30px;
	}
</style>